import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const LOGO = "/majnun-logo.png";
const AUDIO = "/intro-theme.mp3?v=3";
const COLLAGE =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_fort-worth-style/artifacts/b5h5gswl_CCCEF54E-8DB2-4C8E-ADDE-6DA1BD374E30.webp";

let introAudio; // module-level so playback survives component unmount

const Intro = ({ onEnter }) => {
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    introAudio = new Audio(AUDIO);
    introAudio.preload = "auto";
    const html = document.documentElement;
    const body = document.body;
    const prevHtml = html.style.overflow;
    const prevBody = body.style.overflow;
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    return () => {
      html.style.overflow = prevHtml;
      body.style.overflow = prevBody;
    };
  }, []);

  const enter = () => {
    if (closing) return;
    if (introAudio) {
      introAudio.currentTime = 0;
      introAudio.volume = 1;
      introAudio.play().catch(() => {});
    }
    setClosing(true);
    setTimeout(onEnter, 700);
  };

  return createPortal(
    <div
      data-testid="intro-overlay"
      role="button"
      tabIndex={0}
      onClick={enter}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && enter()}
      className="flex flex-col items-center justify-center cursor-pointer select-none overflow-hidden bg-[#050505]"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2147483647,
        opacity: closing ? 0 : 1,
        transition: "opacity 700ms ease",
      }}
    >
      {/* collage texture background */}
      <div
        className="absolute inset-0 bg-cover bg-center intro-collage"
        style={{ backgroundImage: `url(${COLLAGE})` }}
      />
      <div className="absolute inset-0 bg-[#050505]/78" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/40 to-[#050505]/80" />

      {/* radiant light behind logo */}
      <div
        className="absolute w-[70vw] h-[70vw] max-w-[560px] max-h-[560px] rounded-full intro-glow"
        style={{
          background:
            "radial-gradient(circle, rgba(91,42,134,0.85) 0%, rgba(91,42,134,0.22) 38%, transparent 70%)",
          filter: "blur(18px)",
        }}
      />

      <img
        src={LOGO}
        alt="MAJNUN"
        className="relative w-[70vw] max-w-[400px] object-contain intro-logo drop-shadow-[0_0_35px_rgba(0,0,0,0.9)]"
      />

      <div className="relative mt-12 flex flex-col items-center intro-cta">
        <p
          data-testid="intro-cta"
          className="text-sm sm:text-base font-mono uppercase tracking-[0.4em] text-[#EAE6DF] animate-pulse"
        >
          Click to follow the light
        </p>
        <span className="mt-5 h-px w-40 bg-gradient-to-r from-transparent via-[#EAE6DF] to-transparent" />
      </div>

      <p className="absolute bottom-8 text-[10px] font-mono uppercase tracking-[0.3em] text-muted-foreground">
        Fort Worth, Texas
      </p>
    </div>,
    document.body
  );
};

export default Intro;
